// TODO: Remove all GSD_THEME constants
export const GSD_THEME = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
  AB_SPLIT: 'ab'
}
